


















































































import { defineComponent } from '@vue/composition-api';

import { Direction } from '@/types';

import {
  SldsButton,
  SldsIcon,
  SldsMenu,
  SldsMenuItem,
  SldsMenuIcon,
} from '@ui';

import { useDI, useViewer, useConnections } from '@/composables';

import ConnectedOrg from '@/components/CoonnectedOrg/ConnectedOrg.vue';

export default defineComponent({
  name: 'AppGlobalHeader',
  components: {
    SldsButton,
    SldsIcon,
    SldsMenu,
    SldsMenuItem,
    SldsMenuIcon,
    ConnectedOrg,
  },
  setup() {
    const { container, Tokens } = useDI();
    const salesforceService = container.get(Tokens.SalesforceService);
    const { viewer } = useViewer();
    const {
      sourceConnection,
      targetConnection,
      isSourceConnected,
      isTargetConnected,
    } = useConnections();

    async function disconnect(direction: Direction) {
      await salesforceService.disconnect(direction);
      window.location.reload();
    }

    return {
      viewer,
      sourceConnection,
      targetConnection,
      isSourceConnected,
      isTargetConnected,
      disconnect,
      Direction,
    };
  },
});
